<div class="app-container app-container-p h-full flex flex-col md:grid grid-cols-12 gap-2 md:gap-4 pt-6 items-center justify-items-center md:justify-items-start">
    <span class="hidden md:block md:col-span-4 uppercase" i18n="@@getInTouchContactUs">Contact Us</span>

    <a
        (click)="contactUsDialogService.openContactUsDialog()"
        class="group text-center md:text-start col-span-12 md:col-span-4 link heading-2 flex items-end justify-self-center text-white font-bold mb-4 md:m-0"
        href="javascript:;"
    >
        <span class="text-white group-hover:underline underline-offset-8" i18n="@@getInTouchCta"> Get in Touch</span>
        <span id="arrow" class="text-white text-xl ml-2 material-symbols-outlined">arrow_outward</span>
    </a>

    <p class="max-w-xs col-span-12 md:col-span-4 text-center md:text-start justify-self-end" i18n="@@getInTouchDescription">
        Do you have any queries or comments about our website, our products or any of our services?
    </p>
</div>
